import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _URL from '@babel/runtime-corejs3/core-js/url';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js/instance/starts-with';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import { api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { prependPrefix } from '../../../utils/style.js';
import { useHeaderContext } from '../context.js';

var LEFT_NAV_MAP = [{
  key: 'home',
  name: '主站',
  url: api.MISSEVAN_SITE_MAIN,
  icon: true
}, {
  key: 'fm',
  name: '直播间',
  url: api.MISSEVAN_FM_API_PREFIX_URL
}, {
  key: 'event',
  name: '活动',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/mevent/list"),
  path: ['/blackboard/', '/mevent/', '/mtopic/']
}, {
  key: 'app',
  name: '手机客户端',
  url: "".concat(api.MISSEVAN_SITE_MAIN, "/app"),
  path: ['/app']
}];

var isActive = function isActive(url, path) {
  if (window.location.pathname && path) {
    // TODO: 需要 try catch
    var urlDetail = new _URL(url);

    if (urlDetail.origin !== window.location.origin) {
      return false;
    }

    for (var i = 0; i < path.length; i++) {
      var currentPath = window.location.pathname;

      if (_startsWithInstanceProperty(currentPath).call(currentPath, path[i])) {
        return true;
      }
    }
  }

  return url === window.location.href;
};

var NavLinks = function NavLinks() {
  var _useHeaderContext = useHeaderContext(),
      isMobileView = _useHeaderContext.isMobileView;

  return isMobileView ? /*#__PURE__*/React.createElement("a", {
    href: api.MISSEVAN_MOBILE_API_PREFIX_URL,
    className: prependPrefix('logo')
  }) : /*#__PURE__*/React.createElement("ul", {
    className: prependPrefix('nav')
  }, _mapInstanceProperty(LEFT_NAV_MAP).call(LEFT_NAV_MAP, function (_ref) {
    var key = _ref.key,
        name = _ref.name,
        url = _ref.url,
        icon = _ref.icon,
        path = _ref.path;
    return /*#__PURE__*/React.createElement("li", {
      key: key,
      className: classNames(prependPrefix('item'), prependPrefix(key), _defineProperty({}, prependPrefix('active'), isActive(url, path)))
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      target: "_blank"
    }, icon && /*#__PURE__*/React.createElement("i", null), name));
  }));
};

export { NavLinks };
